import { FC, ReactElement, useMemo } from 'react'
import classNames from 'classnames'

import { CalendarShiftPlanning } from '@/containers/Calendar/subcomponents/CalendarShiftPlanning/CalendarShiftPlanning'
import { CalendarShiftTrackTime } from '@/containers/Calendar/subcomponents/CalendarShiftTrackTime/CalendarShiftTrackTime'
import { ScheduleShift } from '@/entities/Shift/Shift'
import { shouldShowEndTime } from '@/helpers/tools'
import { useTypedSelector } from '@/redux/store'

import './CalendarShift.scss'

interface CalendarShiftProps {
    shift: ScheduleShift
}

export const CalendarShift: FC<CalendarShiftProps> = ({ shift }): ReactElement => {
    const settings = useTypedSelector(state => state.userReducer.settings)
    const showEndTime = shouldShowEndTime(settings, shift.department.id)

    const isPast = useMemo(() => new Date() > new Date(shift.period.start), [shift])

    return (
        <div className={classNames('calendar-shift', { 'calendar-shift--is-past': isPast })}>
            <div className="calendar-shift-inner">
                <CalendarShiftTrackTime shiftPeriod={shift.period} showEndTime={showEndTime} />
                <div className="calendar-shift__department">
                    { shift.department.name }
                </div>

                <ul className="calendar-shift__shift-plannings-list">
                    { shift.shiftPlannings.map((shiftPlanning, index) => (
                        <li key={index} className="calendar-shift__shift-planning-item">
                            <CalendarShiftPlanning shiftPlanning={shiftPlanning} shiftPeriod={shift.period} showEndTime={showEndTime} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
